module.exports = __webpack_public_path__ + "static/media/skull.6687ea2d.gif";